import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SelectReportType.css';
import { getReportTypeInfo, WizardStepID } from '../GenerateReportWizardUtils';
import Badge from '../../../../Components/Badge/Badge';
import { ReportType } from '../../../../Utils/Constants';

class SelectReportType extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired,
    wizard: PropTypes.any
  };
  static propTypes = {
    setReportType: PropTypes.func.isRequired,
    reportTypeSelected: PropTypes.string,
    isBig: PropTypes.bool.isRequired,
    isVirtualEventsEnabled: PropTypes.bool.isRequired
  };

  render() {
    const { t } = this.context;
    const { isVirtualEventsEnabled } = this.props;
    let reportTypes = [
      ReportType.SESSIONS_OVERVIEW_REPORT,
      ReportType.WEBINAR_REGISTRATION_REPORT,
      ReportType.SESSIONS_ATTENDANCE_REPORT,
      ReportType.WEBINAR_ATTENDEE_REPORT,
      ReportType.WEBINAR_QANDA_REPORT,
      ReportType.SESSIONS_QANDA_FOLLOW_UP_REPORT,
      ReportType.WEBINAR_PERFORMANCE_REPORT,
      ReportType.WEBINAR_RECORDING_REPORT,
      ReportType.WEBINAR_SURVEY_REPORT
    ];

    if (isVirtualEventsEnabled) {
      reportTypes = [
        ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT,
        ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT,
        ...reportTypes
      ];
    }

    const buildReportTypeCards = reportTypes.map(reportType => (
      <ReportCard
        key={reportType}
        {...getReportTypeInfo(reportType)}
        reportType={reportType}
        reportTypeSelected={this.props.reportTypeSelected}
        onClick={() => this.selectReportType(reportType, this.props.isBig)}
        isBig={this.props.isBig}
      />
    ));
    return (
      <div className="reportCardLayout">
        {this.props.isBig && <div className="selectReport">{t('generateReport.wizard.reportTypeTitle')}</div>}
        <div className="reportCards">{buildReportTypeCards}</div>
      </div>
    );
  }

  selectReportType = (reportType, isBig) => {
    const { setReportType } = this.props;
    const { push } = this.context.wizard;
    if (reportType) {
      reportType = !isBig && reportType === this.props.reportTypeSelected ? null : reportType;
      setReportType(reportType);
      isBig && push(WizardStepID.FILTER_RECORDS);
    }
  };
}

export const ReportCard = (
  { iconClass, title, description, isNewReport, onClick, reportType, isBig, reportTypeSelected, isVeryNewReport },
  { t }
) => {
  return (
    <div className={`reportCard ${reportTypeSelected === reportType ? 'selected' : 'unSelected'}`} onClick={onClick}>
      {isVeryNewReport || isNewReport ? (
        <div className="veryNewIcon">{AppendBadge(t('badges.new'), isVeryNewReport)}</div>
      ) : (
        ''
      )}
      <div className="reportHeading">
        <div className={`${iconClass}`} />
        <div className="reportTitle">{title}</div>
      </div>
      {(isBig || reportTypeSelected === reportType) && <div className="reportDescription">{description}</div>}
    </div>
  );
};

ReportCard.contextTypes = {
  t: PropTypes.func.isRequired
};

export const AppendBadge = (label, isVeryNewReport) => {
  return (
    <span className="session-display">
      <Badge label={label} isVeryNewReport={isVeryNewReport} />
    </span>
  );
};

export default SelectReportType;



// WEBPACK FOOTER //
// ./src/GoToWebinar/GenerateReport/Wizard/Steps/SelectReportType.js